import axios from "axios";

export const state = {
    news: [],
};

export const getters = {
    news: state => state.news,
};

export const mutations = {
    setnews(state, newValue) {
        state.news = newValue
    },
};

export const actions = {
    fetchNews({ commit }) {
        axios.get('https://fdc.ug/wp-json/wp/v2/posts').then(res => {
            commit('setnews', res.data)
        })
    },
};
